export default __webpack_public_path__ + "static/media/Choosing11PlusSchoolBanner.5b58ed56.jpg";